<template>
  <div style="margin: 15px 30px 0">
    <el-table :data="items" style="width: 100%">
      <el-table-column label="备份实例">
        <template #default="scope">
          网站云实例ID/名称：
          <el-link type="primary" :underline="false" :href="getUrl(scope.row.host)" target="_blank">
            {{ getUniqueName(scope.row.host) }}
            <span v-if="scope.row.host && scope.row.host.nickName">（{{ scope.row.host.nickName }}）</span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="备份时间">
        <template #default="scope">
          {{ scope.row.backup.backupDate }}
        </template>
      </el-table-column>
      <el-table-column label="备份策略">
        <template #default="scope">
          {{ scope.row.backup.isSystem ? '自动备份' : '手动备份' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template #default="scope">
          <div class="actions">
            <el-link
              type="danger"
              :underline="false"
              href="javascript:;"
              v-if="!scope.row.backup.isSystem"
              @click.prevent="btnDeleteClick(scope.row.backup)"
            >
              删 除
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-divider></el-divider>

    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click.prevent="btnBackupClick">新建备份</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api, { IGetResultItem } from '@/api/admin/backups';
import utils from '@/utils';
import { IHost, IHostBackup } from '@/types/models';

interface IState {
  items: IGetResultItem[];
}

export default defineComponent({
  name: 'Backups',
  data() {
    return {
      items: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        if (!res) return;
        this.items = res.items;
      });
    },

    apiDelete(backupId: number) {
      api.delete(backupId, (res) => {
        if (!res) return;
        utils.success('系统备份删除成功！');
        this.apiGet();
      });
    },

    getUniqueName(host: IHost): string {
      if (!host) return '系统备份';
      return utils.getHostUniqueName(host);
    },

    getUrl(host: IHost): string {
      if (!host) return '#';
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    btnBackupClick() {
      api.submit((res) => {
        if (!res) return;
        utils.success('系统备份成功！');
        this.apiGet();
      });
    },

    btnDeleteClick(backup: IHostBackup) {
      if (backup.isSystem) return;
      utils.alertDelete(
        {
          title: '删除系统备份',
          text: `此操作将删除系统备份 ${backup.backupDate}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(backup.id);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
